[
  {
    "id": "power_0001",
    "requirement": 8,
    "reward": {
      "type": "energy",
      "duration": 900000
    }
  },
  {
    "id": "power_0002",
    "requirement": 28,
    "reward": {
      "type": "powerups_combo",
      "subType": "lollipop_firecracker",
      "amount": 1
    }
  },
  {
    "id": "power_0003",
    "requirement": 63,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "amount": 1
    }
  },
  {
    "id": "power_0004",
    "requirement": 128,
    "reward": {
      "type": "gems",
      "amount": 60
    }
  },
  {
    "id": "power_0005",
    "requirement": 153,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "power_0006",
    "requirement": 178,
    "reward": {
      "type": "powerups_combo",
      "subType": "firecracker_balloon",
      "amount": 1
    }
  },
  {
    "id": "power_0007",
    "requirement": 258,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "power_0008",
    "requirement": 328,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 1
    }
  },
  {
    "id": "power_0009",
    "requirement": 373,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_2",
      "amount": 2
    }
  },
  {
    "id": "power_0010",
    "requirement": 478,
    "reward": {
      "type": "gems",
      "amount": 100
    }
  },
  {
    "id": "power_0011",
    "requirement": 508,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "power_0012",
    "requirement": 538,
    "reward": {
      "type": "boosters",
      "subType": "bullet",
      "amount": 1
    }
  },
  {
    "id": "power_0013",
    "requirement": 638,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "amount": 3
    }
  },
  {
    "id": "power_0014",
    "requirement": 688,
    "reward": {
      "type": "multiplier",
      "subType": 2,
      "duration": 900000
    }
  },
  {
    "id": "power_0015",
    "requirement": 788,
    "reward": {
      "type": "gems",
      "amount": 100
    }
  },
  {
    "id": "power_0016",
    "requirement": 863,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "duration": 900000
    }
  },
  {
    "id": "power_0017",
    "requirement": 888,
    "reward": {
      "type": "powerups_combo",
      "subType": "lollipop_firecracker",
      "amount": 1
    }
  },
  {
    "id": "power_0018",
    "requirement": 988,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 1
    }
  },
  {
    "id": "power_0019",
    "requirement": 1188,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_3",
      "amount": 1
    }
  },
  {
    "id": "power_0020",
    "requirement": 1238,
    "reward": {
      "type": "powerups",
      "subType": "bomb",
      "amount": 3
    }
  },
  {
    "id": "power_0021",
    "requirement": 1313,
    "reward": {
      "type": "multiplier",
      "subType": 2,
      "duration": 1800000
    }
  },
  {
    "id": "power_0022",
    "requirement": 1463,
    "reward": {
      "type": "gems",
      "amount": 100
    }
  },
  {
    "id": "power_0023",
    "requirement": 1513,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "power_0024",
    "requirement": 1588,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "duration": 900000
    }
  },
  {
    "id": "power_0025",
    "requirement": 1638,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 3
    }
  },
  {
    "id": "power_0026",
    "requirement": 1713,
    "reward": {
      "type": "multiplier",
      "subType": 2,
      "duration": 900000
    }
  },
  {
    "id": "power_0027",
    "requirement": 1913,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "power_0028",
    "requirement": 2163,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 1
    }
  },
  {
    "id": "power_0029",
    "requirement": 2213,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "power_0030",
    "requirement": 2313,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "duration": 1800000
    }
  },
  {
    "id": "power_0031",
    "requirement": 2563,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "power_0032",
    "requirement": 2863,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "amount": 3
    }
  },
  {
    "id": "power_0033",
    "requirement": 2913,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "power_0034",
    "requirement": 3013,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "duration": 900000
    }
  },
  {
    "id": "power_0035",
    "requirement": 3263,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_3",
      "amount": 1
    }
  },
  {
    "id": "power_0036",
    "requirement": 3313,
    "reward": {
      "type": "gems",
      "amount": 100
    }
  },
  {
    "id": "power_0037",
    "requirement": 3413,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "power_0038",
    "requirement": 3663,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "duration": 900000
    }
  },
  {
    "id": "power_0039",
    "requirement": 3963,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 3
    }
  },
  {
    "id": "power_0040",
    "requirement": 4013,
    "reward": {
      "type": "multiplier",
      "subType": 2,
      "duration": 900000
    }
  },
  {
    "id": "power_0041",
    "requirement": 4113,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "power_0042",
    "requirement": 4363,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 1
    }
  },
  {
    "id": "power_0043",
    "requirement": 4413,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "power_0044",
    "requirement": 4513,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "duration": 1800000
    }
  },
  {
    "id": "power_0045",
    "requirement": 4763,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "power_0046",
    "requirement": 5063,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "amount": 3
    }
  },
  {
    "id": "power_0047",
    "requirement": 5113,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "power_0048",
    "requirement": 5213,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "duration": 900000
    }
  },
  {
    "id": "power_0049",
    "requirement": 5463,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_3",
      "amount": 1
    }
  },
  {
    "id": "power_0050",
    "requirement": 5513,
    "reward": {
      "type": "gems",
      "amount": 100
    }
  },
  {
    "id": "power_0051",
    "requirement": 5613,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "power_0052",
    "requirement": 5863,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "duration": 900000
    }
  },
  {
    "id": "power_0053",
    "requirement": 6163,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 3
    }
  },
  {
    "id": "power_0054",
    "requirement": 6213,
    "reward": {
      "type": "multiplier",
      "subType": 2,
      "duration": 900000
    }
  },
  {
    "id": "power_0055",
    "requirement": 6313,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "power_0056",
    "requirement": 6563,
    "reward": {
      "type": "powerups",
      "subType": "cube",
      "amount": 1
    }
  },
  {
    "id": "power_0057",
    "requirement": 6613,
    "reward": {
      "type": "energy",
      "duration": 1800000
    }
  },
  {
    "id": "power_0058",
    "requirement": 6713,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "duration": 1800000
    }
  },
  {
    "id": "power_0059",
    "requirement": 6963,
    "reward": {
      "type": "chest",
      "subType": "frenzy_chest_1",
      "amount": 1
    }
  },
  {
    "id": "power_0060",
    "requirement": 7263,
    "reward": {
      "type": "boosters",
      "subType": "dart",
      "amount": 3
    }
  }
]
